import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: () =>
    api
      .send({
        query: gql`
          query situacionComprobante {
            TYPES {
              SituacionComprobante {
                readAll {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `,
        variables: {},
      })
      .then((result) => result.data.data.TYPES.SituacionComprobante.readAll),
};
